interface BrandImageProps {
  className?: string;
  alt?: string;
}

const visionMarkPaths = [
  'M235.204 0.00371553C248.577 -1.05965 266.071 0.80031 279.025 4.08134C321.851 14.9379 355.944 41.3936 379.081 80.9942C369.506 83.0694 361.668 85.0289 352.427 88.3118C334.287 60.4921 307.367 40.5409 276.568 32.0848C242.135 22.6406 205.571 28.3508 175.139 47.925C159.339 58.3571 144.486 72.4608 134.351 89.2161C125.29 104.199 116.542 117.611 100.832 125.599C85.4348 133.426 70.9804 132.983 55.1836 127.225C57.0411 117.694 59.4229 109.434 62.2723 100.245C76.1058 106.063 87.5611 104.683 98.6471 93.6258C105.155 87.1346 108.822 79.6498 113.746 71.9757C116.974 66.9722 120.473 62.1697 124.225 57.5986C153.123 22.0669 191.758 3.23287 235.204 0.00371553Z',
  'M405.086 206.953C413.687 205.773 422.954 208.148 431.063 210.981C429.257 220.62 426.89 228.661 424.022 237.924C412.061 232.891 401.265 233.106 390.82 241.685C381.737 249.152 376.974 259.72 370.438 269.414C365.523 276.648 360.048 283.431 354.074 289.693C324.237 321.186 283.864 338.741 241.848 338.483C198.202 338.234 158.964 319.536 128.434 286.666C119.599 276.783 114.004 268.685 107.206 257.234C117.623 254.703 123.548 253.418 133.912 249.947C141.587 261.488 149.549 270.821 159.982 279.695C187.431 303.008 222.416 313.799 257.321 309.712C291.302 305.686 322.498 287.783 344.331 259.765C353.393 248.091 359.097 234.963 369.595 224.53C380.285 213.895 390.647 208.74 405.086 206.953Z',
  'M237.908 51.6435C244.122 51.1438 252.499 51.7239 258.648 52.6243C287.324 56.9127 313.291 73.0306 330.952 97.4938C323.045 101.596 315.422 106.282 308.129 111.52C306.688 109.793 305.189 107.99 303.684 106.335C288.282 89.5344 267.313 79.8547 245.296 79.3793C218.752 78.7401 193.503 91.6318 177.287 114.092C172.962 120.103 168.929 127.398 164.846 133.73C159.3 142.325 154.446 148.191 147.492 155.353C147.319 155.526 147.143 155.695 146.964 155.86C119.152 181.86 86.9086 184.786 51.4987 182.112C50.6126 173.953 51.1443 162.254 51.5466 154.176C87.8297 157.263 120.644 153.711 142.903 118.661C148.578 109.726 153.872 100.119 160.521 91.9726C180.751 67.1847 207.492 53.9175 237.908 51.6435Z',
  'M408.317 154.963C416.343 154.311 426.716 155.157 434.81 155.739C435.659 163.92 435.139 175.537 434.745 183.723C399.489 180.527 366.56 184.104 344.641 217.487C340.271 224.149 336.198 231.301 331.794 237.839C314.776 262.985 289.104 279.903 260.425 284.89C230.03 290.208 201.504 281.918 176.664 262.951C167.861 255.762 162.164 249.804 155.315 240.483C163.887 234.387 170.166 229.411 178.126 221.974C180.868 225.257 183.588 228.363 186.661 231.299C203.461 247.31 225.576 255.476 248.079 253.967C272.669 252.322 295.32 239.218 310.009 218.155C317.875 206.935 322.177 197.066 331.72 185.897C353.036 160.969 377.675 152.421 408.317 154.963Z',
  'M239.099 102.823C258.771 100.831 277.598 110.403 290.445 125.962C283.732 132.532 278.064 138.548 272.142 145.891C268.573 141.434 265.571 138.202 260.716 135.267C248.385 127.887 233.138 129.019 221.881 138.155C213.298 145.195 210.053 155.671 203.579 165.099C179.997 199.452 152.117 218.515 114.32 229.681C94.2307 234.737 81.1307 235.406 60.8445 234.989C57.8088 224.823 56.0126 216.814 53.9814 206.507C101.93 212.122 149.529 194.5 179.343 153.144C185.919 144.621 189.606 134.412 196.224 125.927C207.162 111.893 222.335 104.385 239.099 102.823Z',
  'M404.177 103.702C409.93 103.122 419.318 103.457 425.339 103.58C428.216 113.897 430.065 121.417 432.14 132.043C387.653 125.27 336.719 144.573 308.9 182.373C294.756 201.58 290.073 221.313 266.071 230.884C249.002 237.688 234.285 237.637 217.466 230.03C208.592 225.804 201.935 220.125 195.549 212.421C202.373 206.08 207.932 199.739 213.932 192.572C215.615 194.635 217.237 196.64 219.184 198.437C226.368 205.195 235.812 208.581 245.372 207.83C255.781 207.017 265.318 201.347 271.423 192.343C274.045 188.435 276.946 182.454 279.559 178.092C283.127 172.217 287.096 166.622 291.424 161.356C320.913 124.934 359.802 107.222 404.177 103.702Z'
];

export function AqlVisionMark({ className = '', alt = 'AQL Vision mark' }: BrandImageProps) {
  return (
    <svg
      viewBox="45 -4 400 348"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={alt}
      role="img"
    >
      {visionMarkPaths.map((path) => (
        <path key={path} d={path} fill="currentColor" />
      ))}
    </svg>
  );
}

export function AqlVisionBiomorphicMark({ className = '', alt = 'AQL Vision biomorphic mark' }: BrandImageProps) {
  return (
    <svg
      viewBox="0 0 783 407"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={alt}
      role="img"
    >
      <defs>
        <filter id="aql-bio-glow" x="-20%" y="-35%" width="140%" height="170%" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feColorMatrix in="blur" type="matrix" values="0 0 0 0 0.22 0 0 0 0 0.74 0 0 0 0 0.98 0 0 0 0.75 0" />
          <feBlend in="SourceGraphic" />
        </filter>
        <linearGradient id="aql-bio-line" x1="88" y1="80" x2="680" y2="328" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7dd3fc" />
          <stop offset="0.48" stopColor="#e0f2fe" />
          <stop offset="1" stopColor="#fb923c" />
        </linearGradient>
      </defs>

      <g className="aql-bio-waterlines" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeWidth="1.4">
        <path d="M101 202C177 177 235 178 302 202C386 232 454 234 546 203C603 184 652 182 705 202" />
        <path d="M132 254C218 229 292 238 362 259C443 283 514 279 618 246" />
        <path d="M158 143C237 119 316 129 392 153C472 178 548 174 639 139" />
      </g>

      <g className="aql-bio-stage aql-bio-fish" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8" filter="url(#aql-bio-glow)">
        <path d="M156 205C219 125 353 117 445 204C352 294 220 286 156 205Z" />
        <path d="M445 204C493 166 530 150 571 146C552 178 553 232 571 266C528 260 493 241 445 204Z" />
        <path d="M238 199C271 175 324 174 362 202" />
        <path d="M272 142C301 111 349 101 388 123" />
        <path d="M276 266C308 296 361 307 402 284" />
        <path d="M204 199L209 199" />
      </g>

      <g className="aql-bio-stage aql-bio-flatfish" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="7" filter="url(#aql-bio-glow)">
        <path d="M142 210C213 123 417 119 519 203C424 298 219 301 142 210Z" />
        <path d="M519 203C559 181 596 172 641 174C616 195 615 226 641 249C594 248 557 230 519 203Z" />
        <path d="M234 178C296 154 377 158 444 184" />
        <path d="M228 235C294 259 382 258 453 231" />
        <path d="M287 207C342 195 403 196 458 210" />
        <path d="M196 191L201 191M220 218L225 218" />
      </g>

      <g className="aql-bio-stage aql-bio-shrimp" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="7" filter="url(#aql-bio-glow)">
        <path d="M535 139C474 108 365 113 319 171C276 227 334 285 417 279C487 274 538 232 532 187" />
        <path d="M319 171C278 153 236 153 192 175" />
        <path d="M337 160C357 178 367 203 366 231" />
        <path d="M386 129C407 153 418 181 417 210" />
        <path d="M445 125C462 153 470 181 467 211" />
        <path d="M515 149C564 113 618 101 671 111M523 168C578 148 629 148 678 168M404 278C381 306 356 323 330 330M446 266C438 300 425 326 407 344M489 240C502 270 511 297 515 322" />
      </g>

      <g className="aql-bio-stage aql-bio-plant" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="7" filter="url(#aql-bio-glow)">
        <path d="M391 337C376 283 374 229 392 177C404 141 406 108 392 76" />
        <path d="M390 252C348 230 326 195 323 150C364 163 390 195 390 252Z" />
        <path d="M397 223C445 199 471 161 473 111C425 130 397 166 397 223Z" />
        <path d="M382 307C334 295 300 265 281 218C333 220 368 249 382 307Z" />
        <path d="M401 294C456 278 493 244 512 191C458 200 417 235 401 294Z" />
        <path d="M329 336C370 321 416 321 459 337" />
      </g>

      <g className="aql-bio-logo-trace" transform="translate(174 34) scale(1)" stroke="url(#aql-bio-line)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5">
        {visionMarkPaths.map((path, index) => (
          <path key={`trace-${path}`} d={path} style={{ animationDelay: `${7.05 + index * 0.08}s` }} />
        ))}
      </g>

      <g className="aql-bio-logo-fill" transform="translate(174 34)" fill="currentColor">
        {visionMarkPaths.map((path) => (
          <path key={`fill-${path}`} d={path} />
        ))}
      </g>
    </svg>
  );
}

export function AqlVerticalLogo({ className = '', alt = 'AQL logo' }: BrandImageProps) {
  return <img src="/aql-engineering-logo.png" alt={alt} className={className} />;
}

export function AqlSeahorseLogo({ className = '', alt = 'AQL Engineering seahorse logo' }: BrandImageProps) {
  return <img src="/aql-engineering-logo.png" alt={alt} className={className} />;
}
